import UserRoles from "../Shared/Constant/UserRoles";
import axiosInstance from "../Shared/Utils/axiosInstance";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";

const districtId = sessionStorage.getItem("districtId");
const role = sessionStorage.getItem("userRole");
const talukaId = sessionStorage.getItem("talukaId");
const phcId = sessionStorage.getItem("phcId");

export const getAshaByRegionTable = async (
  tribal,
  month,
  year,
  selectedLanguageId
) => {
  let tribalId;
  if (tribal === "Tribal") {
    tribalId = 1;
  }
  if (tribal === "Non-Tribal") {
    tribalId = 2;
  }
  const requestBody = {
    category_id: tribalId,
    month: month,
    year: year,
    languageid: selectedLanguageId + "",
    state: [1],
  };
  if (
    role === UserRoles.PHCHEAD ||
    role === UserRoles.BLOCKHEAD ||
    role === UserRoles.DISTRICTHEAD
  ) {
    requestBody.districtIds = districtId;
    requestBody.talukaIds = talukaId;
    requestBody.phc = phcId;
  }
  try {
    const response = await axiosInstance.post(
      `/api/getAshasByRegiontabel`,
      requestBody
    );
    const decrypt = TokenDecrypt(response.data);
    if (decrypt === null) {
      return [];
    }
    return decrypt;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch ASHA table"
    );
  }
};
